import { useRemoveItemFromCart } from "./use-remove-item-from-cart"

export type CustomCombinationComponent = {
  id: string
  quantity: number
  message: string
}

export function useRemoveCustomCombinationFromCart() {
  const { mutateAsync, isLoading, error } = useRemoveItemFromCart()

  async function removeCustomCombinationFromCart(ids: string[]) {
    const promises = ids.map(async (id) => {
      await mutateAsync({
        cartItemId: id,
      })
    })

    await Promise.all(promises)
  }

  return {
    removeCustomCombinationFromCart,
    isLoading,
    error,
  }
}
